// extracted by mini-css-extract-plugin
export var drawerPaper = "_1u-0";
export var itemImage = "_1u-1";